<div class="">
    <div class="form-search flex flex-wrap -m-4">
        <div class="form-search__container w-full">
            <div class="form-search__result xl:w-1/2 md:w-1/2 w-full p-4">
                <div class="flex flex-wrap">
                    <div class="form-search__result-block xl:w-1/2 md:w-1/2 w-full">
                        <div class="form-search__result-item w-full">
                            <span>{{ $t('Mimimum Deposit Amount') }}</span>
                            <p>{{ currency.min_deposit }} {{ currency.symbol }}</p>
                        </div>
                    </div>
                    <div class="form-search__result-block xl:w-1/2 md:w-1/2 w-full">
                        <div  class="form-search__result-item w-full">
                            <span>{{ $t('Maximum Deposit Amount') }}</span>
                            <p>{{ currency.max_deposit }} {{ currency.symbol }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="components-filter components-filter__form">

        <div class="components-filter__row">
            <div v-show="step == 'amount'" class="components-filter__item">
                <text-user-input @keyup.native="(e) => clearInput(e)" @keypress.native="(e) => handleInput(e)" @paste.native.prevent @drop.native.prevent v-model="amount" :error="errors.amount" label="Amount" />
            </div>
            <div class="components-filter__item">
                <div v-show="step == 'payment'" class="flex flex-wrap w-full">
                    <div class="mt-4 py-3 px-1 border rounded w-full mb-10" id="card-element"></div>
                </div>
            </div>
        </div>
        <div class="components-filter__row">
            <div class="components-filter__item">
                <t-button-green @click.stop="submit" class="components-filter__button py-3 px-5" :class="{ 'opacity-75': sending }">
                    <span class="components-filter__icon">
                        <svg v-show="sending" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ step == 'amount' ? 'Enter deposit amount' : 'Purchase ' + amount + ' '+ currency.symbol}}
                    </span>
                </t-button-green>
            </div>
        </div>

    </div>

</div>

